import type { Module } from 'vuex';

import {RootState} from "@/store";

export type ErrorStatus = 'error' | 'success';

export interface ErrorLabelState {
  errorReason: string;
  errorStatus: ErrorStatus;
}

const errorLabelModule: Module<ErrorLabelState, RootState> = {
  namespaced: true,

  state: (): ErrorLabelState => ({
    errorReason: ' ',
    errorStatus: 'error',
  }),

  getters: {
    currentErrorReason: (state): string => state.errorReason,
    currentErrorStatus: (state): ErrorStatus => state.errorStatus,
  },

  mutations: {
    setErrorReason(
      state,
      payload: string
    ) {
      state.errorReason = payload;
    },

    unsetErrorReason(state) {
      state.errorReason = ' ';
      state.errorStatus = 'error';
    },

    setErrorStatus(
      state,
      payload: ErrorStatus
    ) {
      state.errorStatus = payload;
    },
  },

  actions: {
    setErrorReason({ commit }, payload) {
      commit('setErrorReason', payload);
    },

    unsetErrorReason({ commit }) {
      commit('unsetErrorReason');
    },

    setErrorStatus({ commit }, payload) {
      commit('setErrorStatus', payload);
    },
  },
};

export default errorLabelModule; 